import {
  Button,
  Divider,
  InputAdornment,
  ListItemText,
  MenuItem,
  Select,
} from "@mui/material";
import React, { useState } from "react";
import SelectMenuArrow from "assets/images/svg-icons/selectMenuArrow.svg";
import ArrowIcon from "assets/images/svg-icons/arrow-curve-left-right.svg";

// import DropdownIcon from "assets/images/svg-icons/chevron-down.svg";
// import PlusIcon from "assets/images/svg-icons/add-circle.svg";
import FormError from "../FormError";
import MuiTypography from "../MuiTypography";
import MuiBox from "../MuiBox";
import Input from "../Input";
// const CustomDropdownIcon = () => (
//   <img
//     src={DropdownIcon}
//     alt="dropdown"
//     style={{ padding: "5px", marginRight: "10px", cursor: "pointer" }}
//   />
// );
const SelectComponent = ({
  variant = "basic",
  divStyle,
  className,
  onChange,
  onBlur,
  value,
  error,
  errorMsg,
  allowOnBlur = true,
  placeholder = "Select Here",
  optionPlaceholder = "Select Here",
  optionSearch = false,
  label,
  isBorderColor = false,
  name,
  fullWidth = true,
  options = [
    { label: "Oliver Hansen", value: "1" },
    { label: "Van Henry", value: "2" },
    { label: "April Tucker", value: "3" },
    { label: "Ralph Hubbard", value: "4" },
    { label: "Omar Alexander", value: "5" },
    { label: "Carlos Abbott", value: "6" },
    { label: "Miriam Wagner", value: "7" },
    { label: "Bradley Wilkerson", value: "8" },
    { label: "Virginia Andrews", value: "9" },
    { label: "Kelly Snyder", value: "10" },
  ],
  onClickFunc,
  disabled = false,
  multiple = false,
  icon,
  required = false,
  showmore = false,
  buttonlable = "Add new",
  onShowmore,
  ...rest
}) => {
  // let valueArray = [];
  // if (multiple && value?.length > 0) {
  //   value?.forEach((val) => {
  //     valueArray?.push(options?.find((option) => option?.value === val));
  //   });
  // }

  const MenuProps = {
    PaperProps: {
      sx: {
        maxHeight: 200,
        borderRadius: "8px",
        mt: "4px",
        border: "1px solid",
        borderColor: "background.gray500",
        boxShadow: " 0px 10px 18px -2px #0A090B12",
      },
    },
    disableAutoFocusItem: true,
  };

  const CustomDownArrowIcon = (props) => {
    return <img src={SelectMenuArrow} alt="SelectMenuArrow" {...props} />;
  };

  const [searchText, setSearchText] = useState("");

  return (
    <>
      <div
        style={{ ...divStyle, width: "100%", opacity: disabled ? ".5" : "1" }}
      >
        <MuiBox sx={{ position: "relative" }}>
          {label && (
            <MuiBox
              sx={{
                mb: "6px",
              }}
            >
              <MuiTypography
                variant="16"
                fontWeight={400}
                color="text.darkBlack"
                sx={{ display: "flex", gap: "5px" }}
              >
                {label}
                <MuiTypography sx={{ color: "#FF4D4D !important" }}>
                  {required && " *"}
                </MuiTypography>
              </MuiTypography>
            </MuiBox>
          )}
          <Select
            IconComponent={CustomDownArrowIcon}
            data-variant={variant}
            className={className}
            labelId="demo-multiple-checkbox-label"
            id="demo-multiple-checkbox"
            multiple={multiple}
            error={Boolean(error)}
            value={value}
            fullWidth={fullWidth}
            disabled={disabled}
            onChange={(e) => {
              // setSelected(e.target.value);
              onChange(e.target.value);
            }}
            onBlur={(e) => {
              if (allowOnBlur && onBlur) {
                onBlur(e);
              }
            }}
            name={name}
            onClick={onClickFunc ? onClickFunc : undefined}
            displayEmpty={true}
            renderValue={(selected) => {
              if (
                !selected ||
                (Array.isArray(selected) && selected.length === 0)
              ) {
                return (
                  <p
                    style={{ color: "#708090 !important" }}
                    className="placeholder-text"
                  >
                    {placeholder}
                  </p>
                );
              }
              return multiple
                ? options
                    ?.filter((option) => selected?.includes(option.value))
                    ?.map((x) => x.label)
                    .join(", ")
                : options?.find((item) => item.value === selected)?.label;
            }}
            MenuProps={MenuProps}
            sx={{
              p: 0,
              mt: 0,
              fontSize: "14px",
              "&:hover ": {
                borderColor: error
                  ? "#E12121 !important"
                  : isBorderColor
                  ? "#E6E6E6 !important"
                  : "transparent !important",
              },
              "& .MuiInputBase-input": {
                p: "10px 12px",
                fontSize: "14px",
                fontFamily: "Inter",
                color: "#000",
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderRadius: "8px",
                border: "1px solid !important",
                // boxShadow: error
                //   ? "0px 0px 0px 3px red !important"
                //   : "0px 0px 0px 2px red !important",
                borderColor: error
                  ? "#E12121 !important"
                  : isBorderColor
                  ? "#E6E6E6 !important"
                  : "transparent !important",
                boxShadow: error
                  ? "0px 0px 0px 2px #FFC9C9"
                  : "transparent !important",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: error
                  ? "#E12121 !important"
                  : "#1D4ED8 !important",
                boxShadow: error
                  ? "0px 0px 0px 2px #FFC9C9"
                  : "0px 0px 0px 2px #DBEAFE",
              },
              "& .MuiSelect-icon": {
                top: "50%",
                transform: "translateY(-50%)",
                transition: "transform 0.2s ease",
              },
              "& .MuiSelect-iconOpen": {
                transform: "translateY(-50%) rotate(180deg)",
              },
              // p: "15px",
              // maxHeight: "65px",
              // borderRadius: "15px",
            }}
            // IconComponent={CustomDropdownIcon}
            startAdornment={
              icon && (
                <InputAdornment position="start">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "14px",
                      height: "43px",
                    }}
                  >
                    {icon}
                    <Divider
                      orientation="vertical"
                      variant="middle"
                      flexItem
                      sx={{ backgroundColor: "inputBorder.main" }}
                    />
                  </div>
                </InputAdornment>
              )
            }
            {...rest}
          >
            {optionSearch && (
              <MuiBox
                sx={{ px: 2, py: 1 }}
                onClick={(e) => {
                  e.stopPropagation();
                }}
                onMouseDown={(e) => {
                  e.stopPropagation();
                }}
              >
                <Input
                  placeholder={optionPlaceholder}
                  name={"name"}
                  value={searchText}
                  isSpace={true}
                  isBorderColor={true}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </MuiBox>
            )}
            {options?.map((name) => (
              <MenuItem key={name?.label} value={name?.value}>
                {/* <ListItemText
                  primary={name?.label}
                  sx={{
                    ml: name?.isSub ? 2 : 0,
                    color: "text.black",
                    ".MuiListItemText-primary": { fontSize: "14px" },
                  }}
                /> */}
                <MuiBox
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  {name?.isSub && (
                    <MuiBox sx={{ width: "16px", height: "16px" }}>
                      <img
                        src={ArrowIcon}
                        alt="Subfolder"
                        className="img-full"
                      />
                    </MuiBox>
                  )}
                  <ListItemText
                    primary={name?.label}
                    sx={{
                      ml: name?.isSub ? 2 : 0,
                      color: "text.black",
                      ".MuiListItemText-primary": { fontSize: "14px" },
                    }}
                  />
                </MuiBox>
              </MenuItem>
            ))}
            {showmore && (
              <Button
                type="submit"
                variant="darkButton"
                onClick={onShowmore}
                sx={{
                  maxWidth: "120px",
                  mt: 2,
                  height: "44px",
                  backgroundColor: "button.darkBlue",
                  ml: "15px",
                  borderRadius: "15px",
                  "&:hover": {
                    backgroundColor: "button.darkBlue",
                    boxShadow: "none",
                  },
                }}
                // startIcon={<MuiBox component="img" src={PlusIcon}></MuiBox>}
              >
                <MuiTypography variant="14" fontWeight={400}>
                  {buttonlable}
                </MuiTypography>
              </Button>
            )}
          </Select>
          {error && <FormError errorMsg={errorMsg} />}
        </MuiBox>
      </div>
    </>
  );
};

export default SelectComponent;
